import React, { ChangeEvent } from 'react';
import { FieldItem, FieldItemTitle } from './styles';
import Input from '../Input/Input';
import { cloneDeep } from 'lodash';
import Button from '../Button/Button';
import HoverIcon from '../HoverIcon';
import Collapsible from '../Collapsible/Collapsible';
import { DashboardLink } from 'store/survey/surveyTypes';
import { useTranslation } from 'react-i18next';
import i18n from '../../i18n';

type IOwnProps = {
  onChangeLinks: (links: DashboardLink[]) => any;
  links: DashboardLink[];
  dashboardHeight: number | undefined;
  dashboardWidth: number | undefined;
  onChangeInput: (event: ChangeEvent<HTMLInputElement>) => void;
};

const DashboardLinksEditor: React.FunctionComponent<IOwnProps> = ({
  links,
  onChangeLinks,
  dashboardWidth,
  dashboardHeight,
  onChangeInput,
}) => {
  const { t } = useTranslation('survey');
  const onChange =
    (index: number) => (e: React.ChangeEvent<HTMLInputElement>) => {
      const name = e.target.name;
      const newLinks = cloneDeep(links);
      newLinks[index][name] = e.target.value;
      onChangeLinks(newLinks);
    };

  return (
    <Collapsible
      header={
        <div>
          <span>{t('reportLinks')}</span>{' '}
        </div>
      }
    >
      <div>
        {links.map((link, index) => {
          return (
            <FieldItem
              key={index}
              style={{ margin: '5px', padding: '5px', overflow: 'hidden' }}
            >
              <FieldItemTitle>
                <Input
                  id={`dashbaordname${index}`}
                  type="text"
                  name="name"
                  value={link.name}
                  onChange={onChange(index)}
                  placeholder={i18n.t('linkTitle', { ns: 'survey' })}
                  label={t('title')}
                />
                <Input
                  id={`dashbaordurl${index}`}
                  type="text"
                  name="url"
                  value={link.url}
                  onChange={onChange(index)}
                  placeholder={t('urlOrId')}
                  label={t('urlOrId')}
                />

                <HoverIcon
                  type="x"
                  color="red"
                  onClick={() => {
                    const newLink = cloneDeep(links).filter(
                      (_, ind) => index !== ind
                    );
                    onChangeLinks(newLink);
                  }}
                />
              </FieldItemTitle>
              {/*<Input
              id={`dashbaordicon${index}`}
              type="text"
              name="icon"
              value={link.icon}
              onChange={onChange(index)}
              placeholder={i18n.t("icon}
              label={i18n.t("icon}
            />*/}
            </FieldItem>
          );
        })}
        <Button
          onClick={() => {
            // links.push({} as any);
            onChangeLinks([...links, { name: '', url: '', icon: '' }]);
          }}
          style={{ fontSize: '0.8rem' }}
        >
          {t('addDashboardLinks')}
        </Button>
        <div
          style={{
            display: 'flex',
            gap: '0.5rem',
            margin: '0.5rem',
            marginTop: '1rem',
          }}
        >
          <Input
            type="number"
            name="dashboardWidth"
            id="dashboardWidth"
            min={0}
            max={6}
            value={dashboardWidth}
            onChange={onChangeInput}
            label={t('dashboardWidth')}
            wrapperStyle={{ flexBasis: '50%' }}
          />
          <Input
            type="number"
            min={0}
            name="dashboardHeight"
            id="dashboardHeight"
            value={dashboardHeight}
            onChange={onChangeInput}
            label={t('dashboardHeight')}
            wrapperStyle={{ flexBasis: '50%' }}
          />
        </div>
      </div>
    </Collapsible>
  );
};

export default DashboardLinksEditor;
